<template>
  <div class="login-container">
    <el-form
      ref="loginForm"
      :model="loginForm"
      :rules="loginRules"
      class="login-form"
      autocomplete="on"
      label-position="left"
    >
      <input
        type="hidden"
        name="captchaId"
        value="6473418f-e3c9-4dec-b5ce-b572dcbd3adb"
      >
      <div class="title-container">
        <h3 class="title">bitzoo总后台</h3>
      </div>

      <el-form-item prop="username">
        <i
          class="iconfont icon-yonghu1"
          style="color: #ffffff; margin-left: 20px"
        />
        <el-input
          ref="username"
          v-model="loginForm.username"
          placeholder="请输入用户名"
          name="username"
          type="text"
          tabindex="1"
          autocomplete="on"
        />
      </el-form-item>

      <el-tooltip
        v-model="capsTooltip"
        content="Caps lock is On"
        placement="right"
        manual
      >
        <el-form-item prop="password">
          <i
            class="iconfont icon-mima"
            style="color: #ffffff; margin-left: 20px"
          />
          <el-input
            :key="passwordType"
            ref="password"
            v-model="loginForm.password"
            :type="passwordType"
            placeholder="请输入密码"
            name="password"
            tabindex="2"
            autocomplete="on"
            @keyup.native="checkCapslock"
            @blur="capsTooltip = false"
          />
          <span class="show-pwd" @click="showPwd">
            <!-- <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" /> -->
            <i
              class="iconfont"
              style="color: #ffffff; margin-left: 20px"
              :class="
                passwordType === 'password' ? 'icon-biyan' : 'icon-yanjing'
              "
            />
          </span>
        </el-form-item>
      </el-tooltip>
      <div class="vaildCode">
        <el-form-item style="width: 69%">
          <i
            class="iconfont icon-yanzhengma"
            style="color: #ffffff; margin-left: 20px"
          />
          <el-input
            ref="validCode"
            v-model="loginForm.captcha"
            placeholder="请输入验证码"
            name="validCode"
            type="text"
            tabindex="3"
            autocomplete="on"
            @keyup.enter.native="handleLogin"
          />
        </el-form-item>
        <div>
          <!-- <img :src="captchaimg" @click="getcaptcha()" alt="" /> -->
          <el-image :src="captchaimg" class="image" @click="getcaptcha()" />
        </div>
      </div>
      <el-button
        :loading="loading"
        type="primary"
        style="width: 100%; margin-bottom: 30px"
        class="edit-button"
        @click.native.prevent="handleLogin"
      >登录</el-button>
      <!-- <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;margin:0" @click="logOut">登出</el-button> -->
    </el-form>
  </div>
</template>

<script>
import { validUsername } from '@/utils/validate'
// import SocialSign from './components/SocialSignin'
import md5 from 'js-md5' // 引入Md5加密
import { mapActions } from 'vuex'
export default {
  name: 'Login',
  // components: { SocialSign },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    const validateCode = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    return {
      loginForm: {
        username: '',
        password: '',
        captcha: undefined
      },
      loginRules: {
        username: [
          { required: true, trigger: 'blur', validator: validateUsername }
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePassword }
        ],
        captcha: [{ required: true, trigger: 'blur', validator: validateCode }]
      },
      passwordType: 'password',
      capsTooltip: false,
      loading: false,
      showDialog: false,
      redirect: undefined,
      otherQuery: {},
      captchaimg: `` // 验证码链接
    }
  },

  created() {
  },
  mounted() {
    console.log(process.env.VUE_APP_PROXY_URL)
    clearInterval(window.timer)
    clearInterval(window.timer2)
    clearInterval(window.grouptimer)
    clearInterval(window.chatTimer)
    clearInterval(window.detailChatTimer)
    this.getcaptcha()
    if (this.loginForm.username == '') {
      this.$refs.username.focus()
    } else if (this.loginForm.password == '') {
      this.$refs.password.focus()
    }
  },
  destroyed() {},
  methods: {
    ...mapActions(['resetToken']),
    // 回车登陆
    checkCapslock(e) {
      const { key } = e
      this.capsTooltip = key && key.length === 1 && key >= 'A' && key <= 'Z'
    },
    // 展示或隐藏登陆密码
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    
    // 登陆
    handleLogin() {
      // this.$router.push({path:'/'})
      if (!this.loginForm.captcha) return
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          var _loginForm = JSON.parse(JSON.stringify(this.loginForm))
          _loginForm.password = md5(_loginForm.password)
          this.$api.user
            .userLogin(_loginForm)
            .then((res) => {
              this.$message.success(res)
              this.$router.push({ path: '/' })
              this.loading = false
              localStorage.setItem('token', 'token')
              // localStorage.setItem('token','token')
            })
            .catch((err) => {
              this.getcaptcha()
              this.$message.error(err || '服务器错误，请稍后重试')
              this.loading = false 
              this.loginForm.captcha = ''
            })
        }
      })
    },
    // 获取验证码图片
    getcaptcha() {
      var time = Number(new Date())
      this.captchaimg = this.$api.user.captcha(time)
      console.log(this.captchaimg)
    },
    // 登出
    logOut() {
      // this.resetToken()
      this.$store.dispatch('user/logout')
    }
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}
.vaildCode {
  display: flex;
  justify-content: space-between;
}
.el-form-item__content {
  display: flex;
  align-items: center;
}
/* reset element-ui css */
.login-container {
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;
  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }

  .thirdparty-button {
    position: absolute;
    right: 0;
    bottom: 6px;
  }

  @media only screen and (max-width: 470px) {
    .thirdparty-button {
      display: none;
    }
  }
}
.image {
  width: 123px;
  height: 49px;
}
</style>
